import { useParams, useSearchParams } from 'react-router-dom';

import { CARDS } from 'src/components/Router';
import type { Card } from 'src/types';

export const useCard = (): Card | undefined => {
  const { card } = useParams();
  const [searchParams] = useSearchParams();

  if (card && CARDS.includes(card as Card)) {
    return card as Card;
  }

  if (searchParams.has('card')) {
    const spCard = searchParams.get('card');

    if (CARDS.includes(spCard as Card)) {
      return spCard as Card;
    }
  }

  return undefined;
};
